"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let logger = {
    trace: () => undefined,
    debug: () => undefined,
    info: () => undefined,
    warn: () => undefined,
    error: () => undefined,
};
function setLogger(l) {
    logger = l;
}
exports.setLogger = setLogger;
function getLogger() {
    return logger;
}
exports.getLogger = getLogger;
//# sourceMappingURL=logger.js.map